import * as React from 'react';
import { default as DefaultComponent } from './Start';

export const Start = (props: any): any => {
  return <DefaultComponent {...props} />;
};
